import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { FileService } from 'src/app/services/api/file.service';
import {
  ChangeFileStateMutationResponse,
  ChangeProgrammingFileStateInput
} from '../model/edit-state-dialog.model';

@Injectable({ providedIn: 'root' })
export class ChangeFileStateApiService {
  constructor(private readonly fileService: FileService) {}

  changeProgrammingFileState(
    input: ChangeProgrammingFileStateInput
  ): Observable<ChangeFileStateMutationResponse> {
    return this.fileService
      .changeEstadoItinerarioByArg(input.fileId, input.targetState, input.userName)
      .pipe(
        map((response: Partial<ChangeFileStateMutationResponse> | null | undefined) => ({
          changeEstadoItinerarioByArg: response?.changeEstadoItinerarioByArg === true
        }))
      );
  }
}
